"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text"));
var _Image = _interopRequireDefault(require("../Image"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _TripAdvisor = _interopRequireDefault(require("./TripAdvisor.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Container = _styledComponents.default.div.withConfig({
  displayName: "TripAdvisor__Container",
  componentId: "sc-k4obfb-0"
})(["display:flex;flex-direction:column;"]);
var Row = _styledComponents.default.div.withConfig({
  displayName: "TripAdvisor__Row",
  componentId: "sc-k4obfb-1"
})(["display:flex;flex-direction:row;align-items:center;"]);
var ImageContainer = _styledComponents.default.div.withConfig({
  displayName: "TripAdvisor__ImageContainer",
  componentId: "sc-k4obfb-2"
})(["margin-left:-0.5rem;"]);
var RankingString = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "TripAdvisor__RankingString",
  componentId: "sc-k4obfb-3"
})(["", ";"], function (_ref) {
  var isMobileView = _ref.isMobileView;
  return isMobileView && (0, _styledComponents.css)(["display:inline-block;width:150px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
});
var TripAdvisorCommon = function TripAdvisorCommon(_ref2) {
  var reviewCountText = _ref2.reviewCountText,
    ratingImageUrl = _ref2.ratingImageUrl,
    rankingString = _ref2.rankingString,
    tabIndex = _ref2.tabIndex,
    accessible = _ref2.accessible,
    theme = _ref2.theme,
    isMobileView = _ref2.isMobileView;
  return /*#__PURE__*/_react.default.createElement(Container, {
    tabIndex: tabIndex
  }, /*#__PURE__*/_react.default.createElement(Row, null, /*#__PURE__*/_react.default.createElement(ImageContainer, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
    accessible: accessible,
    centerFocus: false,
    placeHolderBackground: "default",
    src: ratingImageUrl,
    theme: theme
  })), /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    color: "greyDark",
    type: "small",
    theme: theme
  }, reviewCountText)), /*#__PURE__*/_react.default.createElement(Row, null, /*#__PURE__*/_react.default.createElement(RankingString, {
    accessible: accessible,
    color: "greyDarker",
    type: "small",
    theme: theme,
    isMobileView: isMobileView
  }, rankingString)));
};
TripAdvisorCommon.propTypes = _TripAdvisor.default.PropTypes;
var TripAdvisor = function TripAdvisor(_ref3) {
  var reviewCountText = _ref3.reviewCountText,
    ratingImageUrl = _ref3.ratingImageUrl,
    rankingString = _ref3.rankingString,
    isMobileView = _ref3.isMobileView,
    theme = _ref3.theme,
    accessible = _ref3.accessible;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(TripAdvisorCommon, {
      reviewCountText: reviewCountText,
      ratingImageUrl: ratingImageUrl,
      rankingString: rankingString,
      isMobileView: isMobileView,
      tabIndex: tabIndex,
      accessible: accessible,
      theme: theme
    });
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
TripAdvisor.propTypes = _TripAdvisor.default.PropTypes;
TripAdvisor.defaultProps = _TripAdvisor.default.DefaultProps;
var _default = TripAdvisor;
exports.default = _default;